export default "__VITE_ASSET__BtpF6T_v__"